import { action, observable } from "mobx";

import { GET_HOME_CLAIM_VALUATION } from "../../graphql-documents/getHomeClaimValuation.query";

class ValuationStore {
  @observable loading = false;
  @observable error = null;
  @observable valuationData = {};

  constructor({ graphqlQueryService }) {
    this.graphqlQueryService = graphqlQueryService;
  }

  @action.bound
  initialize({ propertyId }) {
    this.propertyId = propertyId;
  }

  @action.bound
  setPropertyId(value) {
    this.propertyId = value;
  }

  @action.bound
  setValuationData(value) {
    this.valuationData = value;
  }

  @action.bound
  setError(value) {
    this.error = value;
  }

  @action.bound
  fetchValuationData() {
    this.loading = true;

    return this.graphqlQueryService
      .query({
        query: GET_HOME_CLAIM_VALUATION,
        variables: {
          property_id: this.propertyId
        }
      })
      .then(({ data }) => {
        this.setError(null);
        this.setValuationData(data.home_claim_valuation);
      })
      .catch(this.setError)
      .finally(
        action(() => {
          this.loading = false;
        })
      );
  }
}

export default ValuationStore;
